import { useQuery } from '@tanstack/react-query';
import { FILTERS_KEY, defaultFiltersState } from '../constants';
export default function useFilters() {
    return useQuery({
        queryKey: FILTERS_KEY,
        queryFn: () => defaultFiltersState,
        staleTime: Infinity,
        initialData: defaultFiltersState
    });
}
